/* eslint-disable react/prop-types */
import { Input } from 'antd'
import { formatCurrency, parseCurrency } from '../utils/masks'

export default function MoneyInput ({ value, onChange }) {
  const handleChange = (e) => {
    const numericValue = parseCurrency(e.target.value)
    onChange(numericValue)
  }

  return (
    <Input
      placeholder="Ex: 500.000,00"
      value={formatCurrency(value)}
      onChange={handleChange}
    />
  )
}
